import { Component, OnInit } from '@angular/core';
import { MotdMessagesService } from '@cl/core/services/motd-messages.service';
import { MotdMessage } from '../../models/motd-messages/motd-message.model';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
    selector: 'cl-header-motd-messages',
    standalone: false,
    templateUrl: './header-motd-messages.component.html',
    styleUrl: './header-motd-messages.component.less',
})
export class HeaderMotdMessagesComponent implements OnInit {
    headerMotdMessages: MotdMessage[];

    constructor(private motdMessagesService: MotdMessagesService, private messageService: NzMessageService) {}

    async ngOnInit(): Promise<void> {
        try {
            this.headerMotdMessages = (await this.motdMessagesService.getAllActiveHeaderMessages()).data;
            this.headerMotdMessages.forEach(async (motdMessage: MotdMessage): Promise<void> => {
                if (!motdMessage.userHasSeenMessage) {
                    await this.motdMessagesService.setMessageSeen(motdMessage);
                }
            });
        } catch (ex) {
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach((error) => {
                    this.messageService.error(error);
                });
                return;
            }

            this.messageService.error('Kļūda atlasot paziņojumus');
            return;
        }
    }

    async dismissMotdMessage(motdMessage: MotdMessage, motdMessageIndex: number): Promise<void> {
        try {
            await this.motdMessagesService.setMessageDismissed(motdMessage);
            this.headerMotdMessages.splice(motdMessageIndex, 1);
            this.messageService.success('Paziņojums vairs netiks rādīts!');
        } catch (ex) {
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach((error) => {
                    this.messageService.error(error);
                });
                return;
            }

            this.messageService.error('Kļūda atzīmējot paziņojumu par nerādāmu');
            return;
        }
    }
}
